import { stockService } from '@/services';

export const stockModule = {
  namespaced: true,
  state: () => ({
    list:{
      data: null,
      response: null,
      status: 'idle'
    },
    listFilters: {},
    export:{
      data: null,
      status: 'idle'
    }
  }),
  mutations: {
    setListError(state, response) {
      state.list.data = null;
      state.list.response = response;
      state.list.status = 'error';
    },
    setListLoading(state) {
      state.list.data = null;
      state.list.response = null;
      state.list.status = 'loading';
    },
    setListSuccess(state, response) {
      state.list.data = response?.data || null;
      state.list.response = response;
      state.list.status = 'success';
    },
    setListFilters(state, request) {
      state.listFilters = { ...JSON.parse(JSON.stringify(request)) }
    },
    setExportError(state) {
      state.export.data = null;
      state.export.status = 'error';
    },
    setExportLoading(state) {
      state.export.data = null;
      state.export.status = 'loading';
    },
    setExportSuccess(state, response) {
      state.export.data = response?.data || null;
      state.export.status = 'success';
    }
  },
  actions: {
    async getStockProducts({ commit }, request) {
      commit('setListLoading');
      commit('setListFilters', request);
      try {
        const user = JSON.parse(localStorage.getItem("user"));
        const response = await stockService.getStockProducts(request.filters, request.pagination, user.customer._id);
        commit('setListSuccess', response);
      } catch (error) {
        commit('setListError', error);
        throw error;
      }
    },
    async exportStockProducts({ commit }, request) {
      commit('setExportLoading');
      try {
        const user = JSON.parse(localStorage.getItem("user"));
        const response = await stockService.exportStockProducts(request.filters, request.language, user.customer._id);
        commit('setExportSuccess', response);
      } catch (error) {
        commit('setExportError', error);
        throw error;
      }
    }
  }
}
